import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import DatetimePicker from "vuetify-datetime-picker";

Vue.use(DatetimePicker);
Vue.use(Vuetify);

export default new Vuetify({});
